import Vue from 'vue';
import VueResource from 'vue-resource';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import '../assets/css/main.css';

// Ensure Vue uses VueResource to allow for $http post and get functionality
Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBLKPanquCRDlLw7NHgbww2mmk7e4s2iDk',
        libraries: 'places'
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
